import React, { useState, useEffect, useRef } from "react";
import { FiSearch } from "react-icons/fi";
import { useUpdateRolePermissionMutation, useGetRoleByIdMutation } from "./Api";
import ToastrService from "../../services/toastService";
import Loader from "../loader/loader";
import { useNavigate, useParams } from "react-router-dom";
import { GoPencil } from "react-icons/go";
import AddRoles from "./AddRoles";


const ManageRolesAndPermissions = () => {

  const { id } = useParams()

  const navigate = useNavigate()

  const [updateRolePermissionApi, { isLoading: updateIsLoading }] = useUpdateRolePermissionMutation()
  const [getRoleByIdApi, { isLoading }] = useGetRoleByIdMutation()


  const [rolePermission, setRolePermission] = useState()
  const [roles, setRoles] = useState([])


  useEffect(() => {
    getRolePermission()
  }, []);

  const getRolePermission = async () => {
    try {
      const response = await getRoleByIdApi({ id: id })
      // console.log(response.data.data[0], 'res')
      if (response?.data?.data?.length > 0) {
        setRolePermission(response.data.data[0].role_permissions)
        setRoles(response.data.data[0])
      } else {
        ToastrService.error("Role not found");
        navigate('/roles')
      }
    } catch (err) {
      console.log(err, 'err')
    }
  }

  const handleCheckboxChange = (index, field) => {
    const updatedPermissions = [...rolePermission];
    updatedPermissions[index] = {
      ...updatedPermissions[index],
      [field]: !updatedPermissions[index][field],
    };
    setRolePermission(updatedPermissions);
  };

  const handleSubmit = async () => {
    try {
      const response = await updateRolePermissionApi({ role_permissions: rolePermission, role_name: roles.role_name })
      if (response?.data?.success) {
        ToastrService.success(response.data.message);
        navigate('/roles')
      } else {
        ToastrService.error(response.error.data.message);
      }
    } catch (err) {
      console.log(err)
    }
  }

  /*Drawerr open close*/
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  // Open drawer for creating new user
  const handleUpdateUser = () => {
    console.log('=====')
    setIsDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
  };

  const handleSave = (userData) => {
    console.log("New user data:", userData);
    // Call API here to save user
    handleCloseDrawer();

    // for get new data after new role upload
    // setStatus(true)

  };

  return (
    <div>
      {isLoading || updateIsLoading ? <Loader /> :
        <div>
          {/* Header */}
          <div className="page-header">
            <div className="page-header-left d-flex align-items-center">
              <ul className="breadcrumb mb-0">
                <li className="breadcrumb-item">Roles & Permission Management</li>
                <li className="breadcrumb-item active">Permissions</li>
              </ul>
            </div>
          </div>

          <div className="main-content">
            <div className="row">
              <div className="p-6">
                {/* Title */}

                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div>
                    <h3 className="h4 mb-1 drawer-header">
                      Roles & Permission
                    </h3>
                    <p className="mb-0 text-muted">
                      Manage Roles and Permissions.
                    </p>
                  </div>
                  <button className="btn btn-primary" onClick={handleSubmit} >
                    Save
                  </button>
                </div>

                {/* <div className="mb-3">
                  <h6 ><span className="text-primary">Role name : </span>{roles.role_displayname}
                    <GoPencil
                      size={18}
                      style={{ cursor: "pointer", marginLeft: "8px" }}
                      onClick={handleUpdateUser}
                    /></h6>
                </div> */}

                <div className="mb-3">
                  <div className="d-flex justify-content-between align-items-start">

                    {/* Left side: Role info */}
                    <h6 className="mb-0">
                      <span className="text-primary">Role name : </span>
                      {roles.role_displayname}

                      <GoPencil
                        size={18}
                        style={{ cursor: "pointer", marginLeft: "8px" }}
                        onClick={handleUpdateUser}
                      />
                    </h6>

                    {/* Right side: View Users */}
                    <span
                      style={{
                        cursor: "pointer",
                        color: "#0d6efd",
                        textDecoration: "underline",
                        fontSize: "14px"
                      }}
                      onClick={() => navigate(`/viewUsers/${roles.id}`)}
                    >
                      View Users
                    </span>
                  </div>
                </div>


                {!isLoading && rolePermission?.length === 0 && (
                  <div colSpan="6" className="no-data">
                    No data found
                  </div>
                )}


                <div className="card p-3 mb-4">

                  <div className="table-responsive">
                    <table className="table table-hover mb-0">
                      <thead>
                        <tr>
                          <th>Module</th>
                          <th>View</th>
                          <th>Create</th>
                          <th>Edit</th>
                          <th>Delete</th>
                        </tr>
                      </thead>
                      <tbody className="pb-5">
                        {!isLoading && rolePermission?.map((item, index) => (
                          <tr key={index}>
                            <td>
                              {item.module_name}
                            </td>
                            <td>
                              <input
                                type="checkbox"
                                checked={item.view}
                                onChange={() => handleCheckboxChange(index, "view")}
                                className="form-check-input"
                                style={{ height: "18px" }}
                              />
                            </td>
                            <td>
                              <input
                                type="checkbox"
                                checked={item.create}
                                onChange={() => handleCheckboxChange(index, "create")}
                                className="form-check-input"
                                style={{ height: "18px" }}

                              />
                            </td>
                            <td>
                              <input
                                type="checkbox"
                                checked={item.edit}
                                onChange={() => handleCheckboxChange(index, "edit")}
                                className="form-check-input"
                                style={{ height: "18px" }}

                              />
                            </td>
                            <td className="text-primary">
                              <input
                                type="checkbox"
                                checked={item.delete}
                                onChange={() => handleCheckboxChange(index, "delete")}
                                className="form-check-input"
                                style={{ height: "18px" }}

                              />
                            </td>
                          </tr>
                        ))}
                        <td>
                          {/* {Admin} */}
                        </td>
                      </tbody>
                    </table>

                  </div>
                </div>

              </div>
            </div>
          </div>
          {isDrawerOpen && (
            <AddRoles
              mode="update"
              roleList={[]} // pass roles from API or state
              onClose={handleCloseDrawer}
              onSave={handleSave}
              data={roles}
            />

          )}
        </div>

      }
    </div>

  );
};

export default ManageRolesAndPermissions;

